import { BACKEND_URL } from "src/hooks/useMetadata";
import { postAPI } from "src/utils/fetch";
import type { FacetField, FetchFacetsParams } from "../types";

export const fetchFacets = async ({
    instance,
    index,
    filters,
}: FetchFacetsParams): Promise<FacetField[]> => {
    const url = new URL(`v1/search/${index}/facets`, BACKEND_URL);
    url.searchParams.set("max_result", "100");
    const response = await postAPI({
        url: url.toString(),
        instance,
        payload: filters as unknown as Record<string, unknown>[],
    });
    return response.json();
};
